import axios from 'axios';
import { apiUrl} from'../Config/Config';

const mem_plan = () => {
    let planLists = [];
    axios.post(apiUrl+"membership/plantypes").then(res => {
        if(res.data.status == "success"){
            let i=0;
            let planlist = res.data.planlist;
            
            for(i; i<planlist.length; i++){
                planLists[i] = { value: planlist[i]['id'], label: planlist[i]['category'] };
            }
            
        }       
    });
    return planLists;
}

const domainList = () => {
    var qs = require('qs');

    let domainlist = [];
    var postobject = {
admin_id : localStorage.getItem('admin_id')

    };

        axios.post(apiUrl+"user/domainlist",qs.stringify(postobject)).then(res => {

        if(res.data.status == "success"){
            let i=0;
            let domainlists = res.data.domainlist;
            
            for(i; i<domainlists.length; i++){
                domainlist[i] = { value: domainlists[i]['domain_id'], label: domainlists[i]['domain_name'] };
            }
            
        }       
    });
   
    return domainlist;
}

const categories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"faq/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}

const categories1 = () => {
    var qs = require('qs');

    var postobject = {
        type: 'all'
    };

    let catelists = [];
    axios.post(apiUrl+"faq/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const adcategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"advertisement/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const guidecategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"guidecategory/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const guidesubcategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"guidesubcategory/sub_categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['sub_cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const year_list = () => {

    let years = [];  
    let start_yr = 1950;
    let end_yr = new Date().getFullYear();
    let diff = end_yr - start_yr;
    // console.log(end_yr, 'end_yr');
    // console.log(diff, 'diff');
    let i=0;
    for(i; i<=diff; i++){
        let opt = start_yr + i;
        years[i] = { value: opt, label: opt };
    }
    return years;
}
export const lang = {

    common: {
        title:'O2 Market',
        status_option:[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
        ],
        status_option2:[
            { value: 'A', label: 'Active' },
            { value: 'I', label: 'Inactive' },
        ],
        status_filter_option:[
            { value: '', label: 'All' },
            { value: 'A', label: 'Active' },
            { value: 'I', label: 'Inactive' },
        ],
        advertisement_linktype:[
            { value: 'external', label: 'External' },
            { value: 'internal', label: 'Internal' },
            // { value: 'offer', label: 'Offer' },
        ],
        linktype:[
            { value: 'external', label: 'External' },
            { value: 'internal', label: 'Internal' },         
        ],
        categories_option: categories(),
        //categories_option1: categories1(),
        adcategories_option: adcategories(),
        //guidecategories_option: guidecategories(),
        //guidesubcategories_option: guidesubcategories(),
        gender_option: [
            { value: 'Male', label: 'Male' },
            { value: 'Female', label: 'Female' },
            { value: 'Transgender', label: 'Transgender' }
        ],
		/* image_size_option: [
            { value: '250x250', label: '250x250' },
			{ value: '350x350', label: '350x350' },
            { value: '520x520', label: '520X520' }
        ],*/
        image_size_option: [
            { value: '1031x400', label: '1031x400 (W X H)' },
            { value: '250x180', label: '250x180 (W X H)' },
			{ value: '200x150', label: '200x150 (W X H)' },
            { value: '180x120', label: '180x120 (W X H)' }
        ],
        coming_source :[
            { value: '0', label: 'Select' },
            { value: 'friends', label: 'Friends' },
            { value: 'facebook', label: 'Facebook' },
            { value: 'instagram', label: 'Instagram' },
            { value: 'messaging apps', label: 'Messaging Apps' },
            { value: 'website', label: 'Website' },
            { value: 'flyers', label: 'Flyers' },
            { value: 'sms', label: 'Sms' },
            { value: 'newspaper', label: 'Newspapers' },
            { value: 'others', label: 'Others' }
        ],
        //  field_options :[
        //     { value: 'text', label: 'Text' },
        //     { value: 'email', label: 'Email' },
        //     { value: 'tel', label: 'Tel' },
        //     { value: 'textarea', label: 'Textarea' },
        //     { value: 'password', label: 'Password' },
        //     { value: 'select', label: 'Select' },
        //     { value: 'checkbox', label: 'Checkbox' },
        //     { value: 'radio', label: 'Radio' },
        //     { value: 'url', label: 'url' },
        //     { value: 'image', label: 'Image' },
        // ],
        field_options :[
             { value: 'profile', label: 'Profile'},
             { value: 'products', label: 'Search Products'},
             { value: 'coupons', label: 'Coupons'},
             { value: 'myReferer', label: 'My Referer'},
             { value: 'wishlist', label: 'Tracking Items'},
             { value: 'mySearches', label: 'My Searches'},
             { value: 'userLikes', label: 'User Likes'},
             { value: 'trending', label: 'Trendings'},
             { value: 'inviteFriends', label: 'Invite Friends'},
             { value: 'myInvite', label: 'My Invites'},
             { value: 'myOnlineUser', label: 'My Online Users'},
             { value: 'groupList', label: 'Groups'},
             { value: 'historyList', label: 'Chat History'},
             { value: 'archivedNotification', label: 'Archived Notifications'},
             { value: 'archivedGroupList', label: 'Archived Groups'},
             { value: 'grpChatDelMsgList', label: 'Deleted Chat History'},
             { value: 'showUsersList', label: 'Company Users'},

             { value: 'networkList', label: 'Networks'},
             { value: 'storeList', label: 'Stores'},
        ],
        discount_option:[
            { value: 'percentage', label: 'Percentage' },
            { value: 'flat', label: 'Flat' },
        ],
        submenu_option : [
            {value:'keyboard_search', label: 'Search Results', func: 'triggerAiSearchProduct'},
            {value:'best_deals', label: "Best Deals", func: 'triggerAiSearchProduct'},
            {value:'user_likes', label: "User Likes", func: 'triggerAiSearchProduct'},
            {value:'tracking_items', label: "Tracking Items", func: 'triggerAiSearchProduct'},
            {value:'trending', label: "Trending", func: 'triggerAiSearchProduct'},
            {value:'my_searches', label: "My Searches", func: 'triggerAiSearchProduct'},
            {value:'ai_chat', label: "AI Chat", func: 'triggerMainChatGpt'},
            {value:'02m_chat', label: "02 Market Chat", func: 'show_chatgroupbox'},
            {value:'ads', label: "Advertisement", func: 'openAdsPopUp'},
            {value:'dashboard', label: "Dashboard", func: 'showdashboard'},
            {value:'userMembershipFunc', label: "Membership Plans", func: 'userMembershipFunc'},
            {value:'triggerSignupFunc', label: "Guest User Membership", func: 'triggerSignupFunc'},
        ],
        advisory_dropdown_option : [
            {value:'Adam56', label: 'Adam56'},
            {value:'compare_product_search', label: "Compare Product Search"},
            {value:'product_search', label: "Product Search"},
            {value:'exit', label: 'Exit'},
            
        ],
        // module_option:[
        //     { value: 'module1', label: 'Module1 (Doctor Listing)' },
        //     { value: 'module2', label: 'Module2 (Product Listing)' },
        // ],
        // productType_option:[
        //     { value: '1', label: 'Normal Product' },
        //     { value: '2', label: 'Shopping Product' },
        //     { value: '3', label: 'Regular Product' },
        // ],
        period_option: [
            { value: 'day', label: 'Daily' },
            { value: 'week', label: 'Week' },
            { value: 'month', label: 'Month' },
            { value: 'year', label: 'Year' }
        ],
        contentType_option:[
            { value: 'description', label: 'Description' },
            { value: 'form', label: 'Form' },
            { value: 'listing', label: 'Listing' },
            { value: 'membership', label: 'Membership' },
            
        ],
        // domainList_option:domainList(),
        mem_plan_option: mem_plan(),
        year_option: year_list(),

        shortcuticon_options :[     
            { value: 'dashboard', label: 'Dashboard'},             
            { value: 'profile', label: 'Profile' },            
            { value: 'aiClickFunc', label: 'AI' },           
            { value: 'show_chatgroupbox', label: 'Chat' },           
            { value: 'triggerSearchProductFunc', label: 'Search Products' },           
            { value: 'bestDealsProdcuts', label: 'Best Deals' },           
            { value: 'trackingProducts', label: 'Trackings' },
            { value: 'userLikeProducts', label: 'User Likes' },            
            { value: 'trendingProducts', label: 'Trendings' },            
            { value: 'companyRoleManageSt', label: 'Role Management' },
            { value: 'companyUserRoleSt', label: 'Team Members' },            
        ], 
        pluginPosition :[
            { value: 'fixed', label: 'Fixed' },       
            { value: 'absolute', label: 'Absolute' }
        ],
        

    },
    Capitalize(str){
        return str.charAt(0).toUpperCase() + str.slice(1);
        }
};


